(function ($) {
    $(document).ready(function () {
        // I only have one form on the page but you can be more specific if need be.
        const $form = $('.mc-embedded-subscribe-form');

        if ($form.length > 0) {
            $('.mc-embedded-subscribe-form input[type="submit"]').bind('click', function (event) {
                if (event) event.preventDefault();
                register($form);
            });
        }
    });

    function register($form) {
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            cache: false,
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            error: function () {
                $form.find('.mce-responses .response').text('Oups...Une erreur est survenue.');
            },
            success: function (data) {
                if (data.result !== "success") {
                    if (data.msg.indexOf('is already subscribed')) {
                        $form.find('.mce-responses .response').text('Vous êtes déjà inscrit à la newsletter.');
                    } else {
                          $form.find('.mce-responses .response').text('Oups...Une erreur est survenue.');
                    }
                } else {
                    // It worked, carry on...
                      $form.find('.mce-responses .response').text('Merci ! Vous allez recevoir votre code de bienvenue par e-mail dans quelques instants.');
                }
            }
        });
    }
})(jQuery);
